import React, { useEffect } from 'react';
import styled from 'styled-components';
import Contact from '../components/Contact/Contact';

const PageContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 150px; // Account for fixed header with larger logo

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-top: 100px; /* Updated for new header height */
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-top: 90px; /* Updated for new header height */
  }
`;

const ContactPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Contact Us - Radyofone | Get Help & Support for Radio Streaming App';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Contact the Radyofone team for help and support. Send us a message or email support@radyofone.com. We respond within 2-4 hours during business days.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://www.radyofone.com/contact');
  }, []);

  return (
    <PageContainer>
      <Contact />
    </PageContainer>
  );
};

export default ContactPage;
